export default __webpack_public_path__ + "static/media/mobilkit.b8e9d5ea.svg";